import React, { FC, Ref } from 'react'
import cx from 'classnames'

interface ITextarea {
  required?: boolean
  name: string
  id: string
  placeholder?: string
  register?: Ref<HTMLTextAreaElement>
  onChange?: (...event) => void
  hasError?: boolean
}

const Textarea: FC<ITextarea> = ({
  required,
  name,
  id,
  placeholder,
  register,
  onChange,
  hasError,
}) => {
  return (
    <textarea
      required={required}
      id={id}
      placeholder={placeholder}
      name={name}
      ref={register}
      onChange={onChange}
      className={cx('input textarea', hasError && 'error')}
    />
  )
}

export default Textarea
